<div class="image" aria-hidden="true">
  <div class="bubble align-items-center justify-content-center align-items-center d-flex" [ngClass]="bubbleClassList">
    @if (!useTextIndex) {
      <i class="fas" [ngClass]="bubbleIconClass"></i>
    }
    @if (useTextIndex) {
      <div class="bubble-text text-center">{{ index }}</div>
    }
  </div>
</div>
<div class="details">
  <div class="mb-3">
    <ng-content />
  </div>
</div>
